<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span>For A.E.C., L.C.B., and L.L.B.,</span></p>
<p class="center"><span><i>gentle tamers—past, present and future.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-dedication.vue?709fa45a